import { render, staticRenderFns } from "./NoteBook.vue?vue&type=template&id=0d5367c4"
import script from "./NoteBook.vue?vue&type=script&lang=js"
export * from "./NoteBook.vue?vue&type=script&lang=js"
import style0 from "./NoteBook.vue?vue&type=style&index=0&id=0d5367c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports